import { render } from "./NewStuff.vue?vue&type=template&id=bebd33a6&scoped=true"
import script from "./NewStuff.vue?vue&type=script&lang=js"
export * from "./NewStuff.vue?vue&type=script&lang=js"

import "./NewStuff.vue?vue&type=style&index=0&id=bebd33a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bebd33a6"]])

export default __exports__